/** @jsxImportSource @emotion/react */
import { applyCategoryFilter, find_category } from "../../../../actions/Tenants/config/utils";
import Plot from "../../../../plotly/Plot";

interface CategoryDistributionProps {
    categories?: any[];
    catField: string;
    layer: any;
    fruits: any[];
    style?: React.CSSProperties;
}

export default function CategoryDistribution({ categories, catField, layer, fruits, style = { width: "100%", height: "100%" } }: CategoryDistributionProps) {

    if (!categories) {
        return null;
    }
    const filteredCategory = applyCategoryFilter(categories, layer);
    const labeledFruit = fruits.map((fruit) => find_category(fruit[catField], filteredCategory)?.label);

    const counted_category = applyCategoryFilter(categories, layer).map((item) => ({ ...item, count: labeledFruit.filter((i) => i === item.label).length })).filter((i) => i.count > 0);
    const colors = counted_category.map((i) => i.color);

    const ripening_class_serie: Plotly.Data = {
        type: "pie",
        labels: counted_category.map((i) => i.label),
        values: counted_category.map((i) => i.count),
        marker: {
            colors,
        }
    };
    return <div>
        <Plot
            data={[ripening_class_serie]}
            useResizeHandler={true}
            style={style}
            layout={{
                autosize: true,
                dragmode: false,
                margin: {
                    l: 10,
                    r: 10,
                    t: 20,
                    b: 10,
                    pad: 0
                },
            }}
            config={{
                displayModeBar: false,
                displaylogo: false,
                staticPlot: true,
                scrollZoom: false,
                doubleClick: false,
                doubleClickDelay: 0,
            }}
        />
    </div>;
}
